export { fetchPrograms } from './fetchPrograms'
export { normalizeProgramsData } from './normalizeProgramsData'
export { fetchDiplomas } from './fetchDiplomas'
export { normalizeDiplomasData } from './normalizeDiplomasData'
